import {IModelMentor, IModelMentorSchoolStudyField, isNotNullOrUndefined,} from 'educat-common-web';
import React from 'react';

interface IConnectedMentorProfileSchoolDetailsProps {
}

interface IExternalMentorProfileSchoolDetailsProps {
    mentor: typeof IModelMentor;
}

interface IMentorProfileSchoolDetailsProps extends IConnectedMentorProfileSchoolDetailsProps,
    IExternalMentorProfileSchoolDetailsProps {
}

interface IMentorProfileSchoolDetailsState {
}


class MentorProfileSchoolDetails extends React.Component<IMentorProfileSchoolDetailsProps, IMentorProfileSchoolDetailsState> {

    render() {
        const mentor = this.props.mentor,
            mentorSchoolStudyFields = mentor?.mentorSchoolStudyFields
                ?.filter((mentorSchoolStudyField: typeof IModelMentorSchoolStudyField) => isNotNullOrUndefined(mentorSchoolStudyField));

        if (!Array.isArray(mentorSchoolStudyFields) || 0 === mentorSchoolStudyFields.length) {
            return null;
        }

        return (
            <div className="school-details-container">
                {mentorSchoolStudyFields?.map((mentorSchoolStudyField: typeof IModelMentorSchoolStudyField) => {
                    const schoolName = mentorSchoolStudyField.schoolStudyFields.school?.name,
                        studyFieldName = mentorSchoolStudyField.schoolStudyFields.studyField?.name;

                    if (!schoolName && !studyFieldName) {
                        return null;
                    }

                    return (
                        <p className="school-details" key={mentorSchoolStudyField.id}>
                            {schoolName}
                            {studyFieldName ? ` | ${studyFieldName}` : null}
                        </p>
                    );
                })}
            </div>
        );
    }
}

export default MentorProfileSchoolDetails;
